import { render, staticRenderFns } from "./PatDgDetail.vue?vue&type=template&id=35a98a6f&scoped=true"
import script from "./PatDgDetail.vue?vue&type=script&lang=js"
export * from "./PatDgDetail.vue?vue&type=script&lang=js"
import style0 from "./PatDgDetail.vue?vue&type=style&index=0&id=35a98a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a98a6f",
  null
  
)

export default component.exports